import { selectionEntities } from "../native/blocks";
import { pixelsPerUnit, displayMeasurement } from "../native/page";
import type { NativeSession } from "../native/session";
import type { NativePointer } from "../native/pointer";
import {
  resizeSelection,
  selectionDimensions,
  setNodeAngle,
} from "../native/selection-commands";

/** Both inspector surfaces use the same document commands and history boundary. */
export class NativeDimensionsInspector {
  constructor(
    private session: NativeSession,
    private pointer: NativePointer,
    changed: () => void,
    message: (text: string, error?: boolean) => void,
    private prefix = "native-",
  ) {
    for (const name of ["width", "height", "angle"] as const) {
      const input = this.field(name);
      input.addEventListener("change", () => {
        if (!pointer.active && input.value.trim()) {
          try {
            const value =
              Number(input.value) *
              (name === "angle" ? 1 : pixelsPerUnit(session.page.unit));
            session.replaceMany(
              name === "angle"
                ? selectionEntities(session.selectedNodes).length === 1
                  ? [
                      setNodeAngle(
                        selectionEntities(session.selectedNodes)[0]!,
                        value,
                      ),
                    ]
                  : []
                : resizeSelection(session.selectedNodes, name, value),
            );
            session.finish();
          } catch (error) {
            message((error as Error).message, true);
          }
        }
        input.blur();
        changed();
      });
      input.addEventListener("keydown", (event) => {
        if (event.key === "Escape") {
          input.value = this.value(name);
          input.blur();
          event.stopPropagation();
        }
      });
    }
  }
  private field(name: string) {
    return document.getElementById(this.prefix + name) as HTMLInputElement;
  }
  private value(name: "width" | "height" | "angle") {
    const size = selectionDimensions(this.session.selectedNodes);
    const value =
      name === "angle"
        ? (selectionEntities(this.session.selectedNodes)[0]?.transform
            .rotation ??
          (selectionEntities(this.session.selectedNodes).length === 1
            ? 0
            : undefined))
        : size?.[name];
    return value === undefined
      ? ""
      : name === "angle" || this.session.page.unit === "px"
        ? String(Math.round(value * 100) / 100)
        : displayMeasurement(value, this.session.page.unit);
  }
  render() {
    for (const name of ["width", "height", "angle"] as const) {
      const input = this.field(name);
      if (name !== "angle") {
        const label = input.parentElement!.firstChild;
        if (label?.nodeType === Node.TEXT_NODE)
          label.textContent = `${name === "width" ? "Ширина" : "Высота"}, ${{ px: "px", mm: "мм", cm: "см" }[this.session.page.unit] || "px"} `;
        input.step = this.session.page.unit === "px" ? "1" : "0.1";
      }
      input.disabled =
        !this.session.selectedNodes.length ||
        this.pointer.active ||
        (name === "angle" &&
          selectionEntities(this.session.selectedNodes).length !== 1);
      if (document.activeElement !== input) input.value = this.value(name);
    }
  }
}
